
<script>
import { crudMethods } from '@state/helpers'
import DatePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import moment from 'moment'
import CommaFormattedNumber from 'vue-comma-formatted-number'

export default {
  components: {
    DatePicker,
    CommaFormattedNumber,
  },
  props: {
    schema: {
      type: Object,
      default: () => {
        return {}
      },
    },
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_API_ENDPOINT,
      parrentURL: '/transaksi/proyek',
      apiUrl: '/web/transaksi/proyek',
      title: 'Proyek',
      pkId: this.$route.params.id ? this.$route.params.id : '',
      pelangganId: '',
      witelId: '',
      namaProyek: '',
      kodeProyek: '',
      namaKontrak: '',
      tanggalMulai: '',
      tanggalBerakhir: '',
      nilaiKontrakBelumPpn: '0',
      keterangan: '',
      segmentId: '',
      statusProyek: 'AKTIF',
      pelanggans: [],
      witels: [],
      segments: [],
      jenisProyek: 'FUNDING',
      jenisProyeks: [
        { id: 'FUNDING', name: 'FUNDING' },
        { id: 'SEWA-BENDERA', name: 'SEWA BENDERA' },
        { id: 'SMART', name: 'SMART' },
        { id: 'HYBRID', name: 'HYBRID' },
      ],
      mekanismePembayaran: 'OTC',
      mekanismePembayarans: [
        { id: 'OTC', name: 'OTC' },
        { id: 'MRC', name: 'MRC' },
        { id: 'TERMIN', name: 'TERMIN' },
      ],
      pemberiKerjaId: '',
      pemberiKerjas: [],
      jumlahTahapanPembayaran: 1,
      jumlahTahapanPembayaranActive: false,
      noAo: [],
      noSid: [],
      noAkunB2p: [],
      dateOptions: {
        format: 'DD-MM-YYYY',
      },
      modalSaveSuccess: false,
      modalAlert: false,
      alertMessage: '',
      disabledSegment: false,
      disabledWitel: false,
    }
  },
  computed: {
    checkValidation() {
      return (
        this.namaProyek === '' ||
        this.kodeProyek === '' ||
        this.namaKontrak === '' ||
        this.tanggalMulai === '' ||
        this.tanggalBerakhir === '' ||
        this.nilaiKontrakBelumPpn === '' ||
        this.nilaiKontrakBelumPpn === '0' ||
        this.keterangan === '' ||
        this.jenisProyek === '' ||
        this.mekanismePembayaran === '' ||
        this.pemberiKerjaId === '' ||
        this.pelangganId === ''
      )
    },
  },
  watch: {
    items: {},
    pemberiKerjaId: {
      handler: function (newVal, oldval) {
        if (newVal !== oldval && this.pemberiKerjas.length > 0) {
          const langsung = this.pemberiKerjas.find(
            (x) => x.id === newVal
          ).is_langsung
          const telkom = this.pemberiKerjas.find(
            (x) => x.id === newVal
          ).is_telkom

          if (langsung) {
            this.disabledSegment = true
            this.segmentId = null
          } else {
            this.disabledSegment = false
          }

          if (!telkom) {
            this.disabledWitel = true
            this.witelId = null
          } else {
            this.disabledWitel = false
          }

          this.getDataSegment()
          if (this.pkId === '') this.kodeProyek = ''
        }
      },
    },
    segmentId: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.pkId === '') this.getKodeProyek()
        }
      },
    },
    pelangganId: {
      handler: function (newVal, oldval) {
        if (newVal !== oldval) {
          if (this.pkId === '') this.getKodeProyek()
        }
      },
    },
    mekanismePembayaran: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal === 'OTC') {
            this.jumlahTahapanPembayaran = 1
            this.jumlahTahapanPembayaranActive = false
          } else if (newVal === 'MRC') {
            var tanggalMulai = moment(this.tanggalMulai, 'DD-MM-YYYY').startOf(
              'month'
            )
            var tanggalBerakhir = moment(
              this.tanggalBerakhir,
              'DD-MM-YYYY'
            ).endOf('month')

            // console.log(tanggalBerakhir.diff(tanggalMulai, 'months', true))
            this.jumlahTahapanPembayaran = Math.round(
              tanggalBerakhir.diff(tanggalMulai, 'months', true)
            )
            this.jumlahTahapanPembayaranActive = true
          } else {
            this.jumlahTahapanPembayaranActive = true
          }
        }
      },
    },
    tanggalMulai: {
      handler: function (newVal, oldval) {
        if (newVal !== oldval) {
          if (this.mekanismePembayaran === 'MRC') {
            var tanggalMulai = moment(newVal, 'DD-MM-YYYY').startOf('month')
            var tanggalBerakhir = moment(
              this.tanggalBerakhir,
              'DD-MM-YYYY'
            ).endOf('month')
            this.jumlahTahapanPembayaran = Math.round(
              tanggalBerakhir.diff(tanggalMulai, 'months', true)
            )
          }
        }
      },
    },
    tanggalBerakhir: {
      handler: function (newVal, oldval) {
        if (newVal !== oldval) {
          if (this.mekanismePembayaran === 'MRC') {
            var tanggalMulai = moment(this.tanggalMulai, 'DD-MM-YYYY').startOf(
              'month'
            )
            var tanggalBerakhir = moment(newVal, 'DD-MM-YYYY').endOf('month')
            this.jumlahTahapanPembayaran = Math.round(
              tanggalBerakhir.diff(tanggalMulai, 'months', true)
            )
          }
        }
      },
    },
  },
  mounted() {
    this.getDataWitel()
    this.getDataPelanggan()
    this.getDataPemberiKerja()
    if (this.pkId !== '') this.getDetailData()
  },
  methods: {
    ...crudMethods,
    save() {
      this.loading = true
      var tanggalMulai = moment(this.tanggalMulai, 'DD-MM-YYYY').startOf(
        'month'
      )
      var tanggalBerakhir = moment(this.tanggalBerakhir, 'DD-MM-YYYY').endOf(
        'month'
      )
      const tahapanTemp = Math.round(
        tanggalBerakhir.diff(tanggalMulai, 'months', true)
      )

      if (
        tahapanTemp < this.jumlahTahapanPembayaran &&
        this.mekanismePembayaran !== 'OTC'
      ) {
        this.alertMessage = 'Lama proyek lebih kecil dari jumlah tahapan'
        this.modalAlert = true
      } else {
        let body = {
          witel_id: this.witelId,
          pemberi_kerja_id: this.pemberiKerjaId,
          pemberi_kerja_segment_id: this.segmentId,
          nama_proyek: this.namaProyek,
          kode_proyek: this.kodeProyek,
          nama_kontrak: this.namaKontrak,
          tanggal_mulai: moment(this.tanggalMulai, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          ),
          tanggal_berakhir: moment(this.tanggalBerakhir, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          ),
          keterangan: this.keterangan,
          pelanggan_id: this.pelangganId,
          nilai_kontrak_belum_ppn: this.nilaiKontrakBelumPpn.replace(/,/g, ''),
          jenis_proyek: this.jenisProyek,
          mekanisme_pembayaran: this.mekanismePembayaran,
          jumlah_tahapan_pembayaran: this.jumlahTahapanPembayaran,
          pemberi_kerja: this.pemberiKerjaId,
          no_ao: this.noAo.join(','),
          no_sid: this.noSid.join(','),
          no_akun_b2p: this.noAkunB2p.join(','),
        }

        let action = 'insertData'
        let url = this.apiUrl

        if (this.pkId !== '') {
          action = 'updateData'
          url = `${this.apiUrl}/${this.pkId}`
        }

        this[action]({ url: url, body: body })
          .then((response) => {
            this.toast('b-toaster-bottom-right', true, ' Berhasil Diupdate')
            this.loading = false

            const { data } = response.data

            if (this.pkId !== '') {
              this.getDetailData()
            } else {
              this.clearForm()
              this.pkId = data.id
              this.modalSaveSuccess = true
            }
          })
          .catch((err) => {
            this.loading = false
            let message = JSON.parse(err.response.request.response)
            this.messageError = message.message
            this.modalError = true
          })
      }
    },
    clearForm() {
      this.namaProyek = ''
      this.kodeProyek = ''
      this.namaKontrak = ''
      this.tanggalMulai = ''
      this.tanggalBerakhir = ''
      this.keterangan = ''
      this.pelangganId = ''
      this.witelId = ''
      this.pkId = ''
    },
    getDetailData() {
      this.listData({
        url: `${this.apiUrl}/${this.pkId}`,
      }).then((response) => {
        const { data } = response.data
        this.namaProyek = data.nama_proyek
        this.kodeProyek = data.kode_proyek
        this.namaKontrak = data.nama_kontrak
        this.tanggalMulai = moment(data.tanggal_mulai, 'YYYY-MM-DD').format(
          'DD-MM-YYYY'
        )
        this.tanggalBerakhir = moment(
          data.tanggal_berakhir,
          'YYYY-MM-DD'
        ).format('DD-MM-YYYY')
        this.keterangan = data.keterangan
        this.witelId = data.witel_id
        this.pelangganId = data.pelanggan_id
        this.noSid = data.no_sid === null ? [] : data.no_sid.split(',')
        this.noAo = data.no_ao === null ? [] : data.no_ao.split(',')
        this.noAkunB2p =
          data.no_akun_b2p === null ? [] : data.no_akun_b2p.split(',')
        this.jenisProyek = data.jenis_proyek
        this.mekanismePembayaran = data.mekanisme_pembayaran
        this.jumlahTahapanPembayaran = data.jumlah_tahapan_pembayaran
        this.pemberiKerjaId = data.pemberi_kerja_id
        this.segmentId = data.pemberi_kerja_segment_id
        this.nilaiKontrakBelumPpn = data.nilai_kontrak_belum_ppn.toString()
      })
    },
    getDataWitel() {
      this.listData({
        url: `web/data/witel`,
      }).then((response) => {
        const { data } = response.data
        this.witels = data
        // this.witelId = data[0].id
      })
    },
    getDataPelanggan() {
      this.listData({
        url: `web/data/pelanggan`,
      }).then((response) => {
        const { data } = response.data
        this.pelanggans = data
      })
    },
    getDataPemberiKerja() {
      this.listData({
        url: `web/data/pemberi-kerja`,
      }).then((response) => {
        const { data } = response.data
        this.pemberiKerjas = data
      })
    },
    getKodeProyek() {
      if (
        this.pelangganId !== '' &&
        this.pemberiKerjaId !== '' &&
        this.segmentId !== ''
      ) {
        let body = {
          pelanggan_id: this.pelangganId,
          pemberi_kerja_id: this.pemberiKerjaId,
          pemberi_kerja_segment_id: this.segmentId,
        }
        this.insertData({
          url: `web/transaksi/kode-proyek`,
          body: body,
        }).then((response) => {
          const { data } = response.data
          this.kodeProyek = data
        })
      }
    },
    getDataSegment() {
      this.listData({
        url: `web/data/pemberi-kerja/${this.pemberiKerjaId}/segments`,
      }).then((response) => {
        const { data } = response.data
        this.segments = data
      })
    },
    handlePPN(e) {
      this.nilaiKontrakBelumPpn = e
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    toast(toaster, append = false, body) {
      this.counter++
      this.$bvToast.toast(`Data ${this.title} ${body}`, {
        title: this.title,
        toaster: toaster,
        solid: true,
        appendToast: append,
        variant: 'success',
      })
    },
  },
}
</script>
<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="row">
        <div class="form-group col-sm-6">
          <label
            >Jenis Proyek
            <span
              v-if="jenisProyek === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <b-form-select
            v-model="jenisProyek"
            :options="jenisProyeks"
            value-field="id"
            text-field="name"
          >
          </b-form-select>
        </div>
        <div class="form-group col-sm-3">
          <label
            >Pemberi Kerja
            <span
              v-if="pemberiKerjaId === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <b-form-select
            v-model="pemberiKerjaId"
            :options="pemberiKerjas"
            value-field="id"
            text-field="nama"
            :disabled="pkId !== ''"
          >
          </b-form-select>
        </div>
        <div class="form-group col-sm-3">
          <label
            >Segmen
            <span
              v-if="pemberiKerjaId !== null"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <b-form-select
            v-model="segmentId"
            :options="segments"
            value-field="id"
            text-field="nama"
            :disabled="pkId !== ''"
          >
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="form-group col-sm-6">
          <label
            >Witel
            <span
              v-if="witelId === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <!-- <b-form-select
            v-model="witelId"
            :options="witels"
            value-field="id"
            text-field="nama"
            :disabled="disabledWitel || pkId !== ''"
          >
          </b-form-select> -->
          <v-select
            v-model="witelId"
            :options="witels"
            label="nama"
            :reduce="(option) => option.id"
            placeholder="Pilih Witel"
            :disabled="disabledWitel || pkId !== ''"
          >
          </v-select>
        </div>
        <div class="form-group col-sm-6">
          <label
            >Pelanggan
            <span
              v-if="pelangganId === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <!-- <b-form-select
            v-model="pelangganId"
            :options="pelanggans"
            value-field="id"
            text-field="nama"
            :disabled="pkId !== ''"
          >
          </b-form-select> -->
          <v-select
            v-model="pelangganId"
            :options="pelanggans"
            label="nama"
            :reduce="(option) => option.id"
            placeholder="Pilih Pelanggan"
            :disabled="pkId !== ''"
          >
          </v-select>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="form-group col-sm-6">
          <label
            >Kode Proyek<span
              v-if="kodeProyek === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Diisi</span
            ></label
          >
          <input
            v-model="kodeProyek"
            type="text"
            class="form-control"
            :disabled="pkId !== ''"
          />
        </div>
        <div class="form-group col-sm-6">
          <label
            >Nama Proyek<span
              v-if="namaProyek === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <input v-model="namaProyek" type="text" class="form-control" />
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="form-group col-sm-6">
          <label
            >Tanggal Mulai<span
              v-if="tanggalMulai === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <date-picker
            v-model="tanggalMulai"
            :config="dateOptions"
          ></date-picker>
        </div>
        <div class="form-group col-sm-6">
          <label
            >Tanggal Berakhir<span
              v-if="tanggalBerakhir === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <date-picker
            v-model="tanggalBerakhir"
            :config="dateOptions"
          ></date-picker>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="form-group col-sm-6">
          <label
            >Nama Kontrak<span
              v-if="namaKontrak === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Dipilih</span
            ></label
          >
          <b-form-textarea
            id="textarea"
            v-model="namaKontrak"
            rows="5"
            max-rows="5"
            no-resize
          ></b-form-textarea>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="form-group col-sm-12">
              <label
                >Mekanisme Pembayaran
                <span
                  v-if="mekanismePembayaran === ''"
                  class="text-danger font-size-11 font-italic"
                  >*Harus Dipilih</span
                ></label
              >
              <b-form-select
                v-model="mekanismePembayaran"
                :options="mekanismePembayarans"
                value-field="id"
                text-field="name"
              >
              </b-form-select>
            </div>
            <div class="form-group col-sm-12">
              <label
                >Jumlah Tahapan
                <span
                  v-if="jumlahTahapanPembayaran === ''"
                  class="text-danger font-size-11 font-italic"
                  >*Harus Diisi</span
                ></label
              >
              <input
                v-model="jumlahTahapanPembayaran"
                type="text"
                class="form-control"
                :disabled="!jumlahTahapanPembayaranActive"
                @keypress="onlyNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="form-group col-sm-6">
          <label
            >Nilai Kontrak Belum PPN<span
              v-if="nilaiKontrakBelumPpn === ''"
              class="text-danger font-size-11 font-italic"
              >*Harus Diisi</span
            ></label
          >
          <comma-formatted-number
            :format-options="{ thousand: ',', precision: 0 }"
            :value="nilaiKontrakBelumPpn"
            class="form-control"
            @input="handlePPN"
          />
        </div>
        <div class="form-group col-sm-6">
          <label>No AO</label>
          <b-form-tags v-model="noAo" placeholder=""></b-form-tags>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="form-group col-sm-6">
          <label>No SID</label>
          <b-form-tags v-model="noSid" placeholder=""></b-form-tags>
        </div>
        <div class="form-group col-sm-6">
          <label>No Akun B2P</label>
          <b-form-tags v-model="noAkunB2p" placeholder=""></b-form-tags>
        </div>
      </div>
    </div>
    <div class="form-group col-sm-12">
      <label
        >Keterangan<span
          v-if="keterangan === ''"
          class="text-danger font-size-11 font-italic"
          >*Harus Diisi</span
        ></label
      >
      <b-form-textarea
        id="textarea"
        v-model="keterangan"
        rows="5"
        max-rows="5"
        no-resize
      ></b-form-textarea>
    </div>
    <div class="col-sm-12">
      <button
        v-if="
          user.role === 'ROOT' ||
          user.role === 'ADMIN' ||
          user.role === 'KABAG-SALES-DELIVERY' ||
          user.role === 'SUPPORT-ADMINISTRASI-NON-AKSES'
        "
        class="btn btn-primary btn-sm rounded-0"
        :disabled="checkValidation"
        @click="save"
        >SIMPAN DATA {{ title.toUpperCase() }}</button
      >
    </div>
    <b-modal
      v-model="modalSaveSuccess"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <h4 class="text-center"> Data Proyek Berhasil Disimpan </h4>
      </div>

      <router-link
        :to="`/transaksi/proyek/${pkId}/view`"
        class="btn btn-block btn-primary btn-sm"
      >
        Tutup
      </router-link>
    </b-modal>
    <b-modal
      v-model="modalAlert"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <h4 class="text-center"> {{ alertMessage }} </h4>
      </div>

      <button
        class="btn btn-block btn-primary btn-sm"
        @click="modalAlert = false"
      >
        Tutup
      </button>
    </b-modal>
  </div>
</template>


<style>
.form-control:disabled,
.form-control[readonly] {
  background-color: #f9f9f9;
  opacity: 1;
}
</style>